export class UITextKeys {
    static readonly MainScreens: string[] = ['App.Dashboards', 'App.System.General', 'App.General', 'App.AutoExpert.General', 'App.AutoExpert']
}